const Upload = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path
      d="M2.25 17C2.25 19.3472 4.15279 21.25 6.5 21.25L17.5 21.25C19.8472 21.25 21.75 19.3472 21.75 17V12.75C21.75 10.4028 19.8472 8.50002 17.5 8.50002L17 8.50002C16.5858 8.50002 16.25 8.8358 16.25 9.25002C16.25 9.66423 16.5858 10 17 10L17.5 10C19.0188 10 20.25 11.2312 20.25 12.75V17C20.25 18.5188 19.0188 19.75 17.5 19.75L6.5 19.75C4.98122 19.75 3.75 18.5188 3.75 17L3.75 12.75C3.75 11.2312 4.98122 10 6.5 10L7 10C7.41421 10 7.75 9.66423 7.75 9.25002C7.75 8.8358 7.41421 8.50002 7 8.50002L6.5 8.50002C4.15279 8.50002 2.25 10.4028 2.25 12.75L2.25 17Z"
      fill="currentColor"
    />
    <path
      d="M8.51825 6.82481C8.2008 6.55874 8.15914 6.0857 8.42521 5.76824L10.6346 3.1322C11.341 2.28927 12.6583 2.28927 13.3648 3.1322L15.5748 5.76815C15.8409 6.08557 15.7993 6.55862 15.4819 6.82474C15.1644 7.09085 14.6914 7.04927 14.4253 6.73185L12.75 4.73361V14.75C12.75 15.1642 12.4142 15.5 12 15.5C11.5858 15.5 11.25 15.1642 11.25 14.75V4.73306L9.57483 6.73176C9.30875 7.04922 8.83571 7.09088 8.51825 6.82481Z"
      fill="currentColor"
    />
  </svg>
);

export default Upload;
